/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import {Column} from '@tanstack/react-table'
import {useTranslation} from 'react-i18next'
import {useSellers} from 'utils/sellerUtils'
import UiTableColumnSelectFilter from 'components/Ui/UiTableColumnSelectFilter'

interface TableFilterSellersProps {
    column: Column<any>
    table: any
}

const TableFilterSellers: React.FC<TableFilterSellersProps> = ({ column, table }) => {
    const { t } = useTranslation()
    const { selectOptions } = useSellers()

    return (
        <UiTableColumnSelectFilter
            value={column.getFilterValue() as (string | number)[]}
            onChange={(val) => column.setFilterValue(val)}
            options={selectOptions}
            placeholder={t('Filter seller')}
        />
    )
}

export default TableFilterSellers
